import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
} from 'apps/shared/scripts/styles/constants';

export const labelClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
});
